import DATATABLE_TRANSLATIONS from "./datatable_translations";

export default class GroupConsultationsDataTable {
  constructor() {
    $(document).ready(function() {
      showGroupConsultationsTable();
    });

    $(document).on("turbo:render", function() {
      showGroupConsultationsTable();
    });

    function showGroupConsultationsTable() {
      $('#group-consultations-datatable').dataTable({
        "order": [],
        "columnDefs": [ {
          "targets"  : 'no-sort',
          "orderable": false,
        }],
        "language": DATATABLE_TRANSLATIONS,
        "processing": true,
        "serverSide": true,
        "ajax": {
          "url": $('#group-consultations-datatable').data('source')
        },
        "pagingType": "full_numbers",
        "columns": [
          {"data": "group_consultation_date"},
          {"data": "duration"},
          {"data": "title"},
          {"data": "consultation_subject"},
          {"data": "actions"}
        ]
        // pagingType is optional, if you want full pagination controls.
        // Check dataTables documentation to learn more about
        // available options.
      });
    }
  }
}
